import { SeriesEvent } from './series-event';
/**
 * Arguments for the `seriesHover` event.
 */
export class SeriesHoverEvent extends SeriesEvent {
}
